import { render, staticRenderFns } from "./record.vue?vue&type=template&id=19ca4696&scoped=true&"
import script from "./record.vue?vue&type=script&lang=js&"
export * from "./record.vue?vue&type=script&lang=js&"
import style0 from "./record.vue?vue&type=style&index=0&id=19ca4696&scoped=true&lang=css&"
import style1 from "./record.vue?vue&type=style&index=1&id=19ca4696&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ca4696",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ca4696')) {
      api.createRecord('19ca4696', component.options)
    } else {
      api.reload('19ca4696', component.options)
    }
    module.hot.accept("./record.vue?vue&type=template&id=19ca4696&scoped=true&", function () {
      api.rerender('19ca4696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/internalAudit/components/record.vue"
export default component.exports